import { render, staticRenderFns } from "./claimAction.vue?vue&type=template&id=526f8598&scoped=true"
import script from "./claimAction.vue?vue&type=script&lang=js"
export * from "./claimAction.vue?vue&type=script&lang=js"
import style0 from "./claimAction.vue?vue&type=style&index=0&id=526f8598&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526f8598",
  null
  
)

export default component.exports